'use client';

import type { BoxProps } from '@chakra-ui/react';

import { useLocaleValue } from '@/__generated__/i18n.next';

import { FooterContent } from './FooterContent';

export const DefaultFooterOnClient: React.FC<BoxProps> = (props) => {
  const locale = useLocaleValue();
  return <FooterContent locale={locale} {...props} />;
};
